import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import WalletList from "./walletList";
import { CURRENCY_SYMBOL } from "../../../constant";
import { IoIosAdd } from "react-icons/io";
import MyBalance from "../../../pages/Profile/components/balance";
import { useNavigate } from "react-router";

const Balance = () => {
  const memberData = useSelector((state) => state.isMemberInfo);

  const [openWallet, setOpenWallet] = useState(false);

  const navigate = useNavigate();

  return (
    <div className="rounded-full bg-base-white dark:bg-base-deep-dark hover:dark:bg-base-hover-deep-dark hover:bg-base-deep-gray rounded-[6px] pr-[3px] pl-[15px] flex items-center gap-[15px] h-[38px] cursor-pointer relative sm:mr-[10px]">
      <div
        onClick={() => {
          setOpenWallet(!openWallet);
        }}
        className="flex items-center gap-[5px]"
      >
        <MyBalance className="dark:text-base-white text-base-dark !text-base" />
      </div>
      <div
        onClick={() => {
          navigate("profile/deposit");
        }}
        className="rounded-full w-[33px] h-[33px] bg-main-color text-white flex items-center justify-center"
      >
        <IoIosAdd className="text-2xl " />
      </div>
      {openWallet && (
        <WalletList setOpenWallet={setOpenWallet} openWallet={openWallet} />
      )}
    </div>
  );
};

export default Balance;
